import React from "react";
import { useField } from "formik";
import { TextField } from "@mui/material";

/**
 * TextField connected to Formik via useField. Only this input re-renders when
 * its value changes, avoiding full step re-renders and input lag on large forms.
 */
const FormikTextField = ({
  name,
  size = "small",
  fullWidth = true,
  ...rest
}) => {
  const [field, meta] = useField(name);
  return (
    <TextField
      {...rest}
      name={field.name}
      value={field.value ?? ""}
      onChange={field.onChange}
      onBlur={field.onBlur}
      error={Boolean(meta.touched && meta.error)}
      helperText={meta.touched && meta.error ? meta.error : rest.helperText}
      size={size}
      fullWidth={fullWidth}
    />
  );
};

export default FormikTextField;
